module.exports = __webpack_public_path__ + "static/media/ebupot-logotype-d.99e3d10f.svg";